import React, { useEffect, useState } from 'react'

import { Footer } from '../components/Footer'
import { TopLogo } from '../components/TopLogo'

const Terms: React.FC = () => {
  const [html, setHtml] = useState<string>('')
  const [error, setError] = useState<string>('')

  useEffect(() => {
    fetch('/legal/terms.html')
      .then((res) => (res.ok ? res.text() : Promise.reject('Not found')))
      .then((text) => {
        const withBold = text.replace(/\*\*(.+?)\*\*/g, '<strong>$1</strong>')
        setHtml(withBold)
      })
      .catch(() => setError('Terms of Service content not found.'))
  }, [])

  return (
    <div id="page-root" className="h-screen overflow-auto relative bg-neutral-50">
      <TopLogo />
      <div className="px-4 py-6 md:py-8 max-w-4xl mx-auto relative">
        <h1 className="text-3xl md:text-4xl font-bold text-neutral-800 mb-4">Terms of Use</h1>
        {error && <div className="text-red-600 mb-4">{error}</div>}
        <div
          id="terms-content"
          className="prose prose-neutral max-w-none bg-white rounded-xl shadow-soft border border-neutral-200 p-4 md:p-8"
          dangerouslySetInnerHTML={{ __html: html }}
        />
      </div>
      <div className="mt-12">
        <Footer />
      </div>
    </div>
  )
}

export default Terms
